/**
 * @hidden
 */
/* tslint:disable:max-line-length */
/* tslint:disable:variable-name */
export var MultiselectMessages = {
    'array': 'Expected initial values of array type. See http://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/#value-selection',
    'object': 'Expected initial values of Object type. See http://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/#value-selection',
    'primitive': 'Expected initial values of primitive type. See http://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/#value-selection'
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dropdowns/dist/es/error-messages.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/error-messages.js
// module chunks = 3